// extracted by mini-css-extract-plugin
export var formContainer = "_bw-0";
export var message = "_bw-1";